const SUPABASE_URL = 'https://szbwqnllhhsawebwhrwj.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6YndxbmxsaGhzYXdlYndocndqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI1MDAzNDgsImV4cCI6MjA4ODA3NjM0OH0.hRIxkoL41qrAYKaVt1iND9ZjILyDpAM5k0TG8lfqKrQ';

async function supabaseInsert(table: string, data: object) {
  const response = await fetch(`${SUPABASE_URL}/rest/v1/${table}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Prefer': 'return=minimal'
    },
    body: JSON.stringify(data)
  });
  if (!response.ok) throw new Error(`Supabase error: ${response.status}`);
}

export async function submitProducerWaitlist(data: {
  company_name: string;
  contact_name: string;
  email: string;
  phone: string;
  state: string;
  tier: string;
}) {
  await supabaseInsert('waitlist_producers', { ...data, source: 'website' });
}

export async function submitExpertWaitlist(data: {
  full_name: string;
  email: string;
  phone: string;
  state: string;
  certification_level: string;
  certification_body: string;
  years_experience: string;
  specialties: string[];
  bio: string;
}) {
  await supabaseInsert('waitlist_experts', { ...data, source: 'website' });
}
